import { TMP_ELEMENT_POSITION, TMP_ELEMENT_SIZE } from '../shared/abstract-boxes';

export function WhatsappWelcomeMessageBoxViewConstructor(services, callbacks, context, siteTypeConfig) {

  let joint = services.joint;
  let companyId = context.companyId;
  let site = context.site;
  let scenarioId = context.scenarioId;

  return joint.shapes.html.AbstractBoxElementWithDragAndDropView.extend({
    numberOfIceBreaker: 0,
    isElementEditable: false,


    angularTemplate: `
<div class="whatsapp-welcome-message">
  {{ 'parameters/quick_replies/details/graph/whatsapp-welcome-message/description' | translate }}
  <div layout="column">
    <md-button ng-click="elementView.addIceBreaker()" ng-disabled="elementView.numberOfIceBreaker >= 4"> 
    {{ 'parameters/quick_replies/details/graph/whatsapp-welcome-message/add-ice-breaker' | translate }}
    </md-button>
  </div>
</div>
`,
    initialize: function () {
      joint.shapes.html.AbstractBoxElementView.prototype.initialize.apply(this, arguments);
      setTimeout(() => this.updateValidity(), 200);
    },

    addIceBreaker: function () {
      services.QuickRepliesFactory.createUniqueId(companyId, site.id, scenarioId)
        .then(response => {
          let iceBreaker = this.createIceBreaker(response.data.id);
          this.model.graph.addCell(iceBreaker);
          this.model.embed(iceBreaker);
          this.numberOfIceBreaker++;
          this.updateValidity();
          this.reorderChildren();
          this.resizeBox();
        },
          services.AlertingFactory.httpErrorHandler());
    },

    // Put userInput action at the end
    reorderChildren: function (moveAChild) {
      let actionBox = this.model;
      let children = actionBox.getEmbeddedCells();

      for (let child of children) {
        actionBox.unembed(child);
      }
      if (moveAChild) {
        // thanks https://stackoverflow.com/a/5306832
        children.splice(moveAChild.newIndex, 0, children.splice(moveAChild.currentIndex, 1)[0]);
      }


      let userInput = null;
      let nextWhatsAppWelcomeMessages = null;
      for (let child of children) {
        if (child.get('type') === 'html.UserInput') {
          // Put it aside for later
          userInput = child;
        } else if (child.get('type') === 'html.NextWhatsappWelcomeMessages') {
          // Put it aside for later
          nextWhatsAppWelcomeMessages = child;
        } else {
          actionBox.embed(child);
        }
      }
      if (nextWhatsAppWelcomeMessages) {
        actionBox.embed(nextWhatsAppWelcomeMessages);
      }
      if (userInput) {
        actionBox.embed(userInput);
      }
    },

    createIceBreaker: function (id, position = TMP_ELEMENT_POSITION, size = TMP_ELEMENT_SIZE, elementData) {
      return new joint.shapes.html.WhatsappIceBreaker({ id, position, size, elementData });
    },

    isChildAlwaysLast: function (child) {
      return 'html.UserInput' === child.get('type');
    },

    // useful for drag and drop, see AbstractBoxElementWithDragAndDropView.repositionOtherChildren
    paddingTop: function () {
      return this.heightOfHTMLContent();
    },

    afterEditElement: function () {
      this.updateValidity();
    },

    checkIceBreaker: function (value) {
      return new RegExp(/^(?![\s\S]{81})(?!.*[\uD800-\uDBFF][\uDC00-\uDFFF])[\s\S]*$/).test(value);
    },

    updateValidity: function () {
      if (!this.angularScope.elementData) {
        this.model.setBoxValid(false);
      } else {
        this.angularScope.elementData.references = {};

        this.angularScope.elementData.values = this.model.getEmbeddedCells()
          .filter((child) => child.get('type') !== 'html.UserInput' && child.get('type') !== 'html.NextWhatsappWelcomeMessages')
          .map(child => {
            const value = child.get('elementData')?.value;
            if (value) {
              this.angularScope.elementData.references[value] = child.id;
            }
            return value;
          }) || [];
        const valid = !((this.angularScope.elementData.values || []).length) || this.angularScope.elementData.values.every(value => {
          return value && this.checkIceBreaker(value)
        });
        this.model.setBoxValid(valid);

        // The watch mecanism to refresh the elementData model is not triggered when the change comes from the children.
        this.model.set('elementData', this.angularScope.elementData);
      }

    },
  });
}
